/* eslint-disable tailwindcss/no-custom-classname */
import type { LabelHTMLAttributes, ReactNode } from 'react'
import { forwardRef } from 'react'
import type { AllVariantPaths } from '../../types/VariantTypes'
import { BrandIcon } from '../../Icons/BrandIcon/BrandIcon'
import clsx from 'clsx'
import SvgFillWarningCircle from '@jotta/ui/SvgFillWarningCircle'
import type { BrandThemeIcon } from '@jotta/types/Brand'
import SvgCheckCircle from '../../generated/icons/SvgCheckCircle'

export function FormFieldErrorMessage({
  errorMessage,
  className,
}: {
  errorMessage: ReactNode
  className?: string
}) {
  return (
    <FormFieldMessage
      className={clsx('text-danger', className)}
      icon={SvgFillWarningCircle}
    >
      {errorMessage}
    </FormFieldMessage>
  )
}

export function FormFieldGoodMessage({
  className,
  children,
}: {
  children: ReactNode
  className?: string
}) {
  return (
    <FormFieldMessage
      className={clsx('text-good', className)}
      icon={SvgCheckCircle}
    >
      {children}
    </FormFieldMessage>
  )
}

export function FormFieldMessage({
  className,
  icon,
  children,
}: {
  className?: string
  icon: BrandThemeIcon
  children: ReactNode
}) {
  return (
    <div className={clsx('body-sm-ln flex items-center gap-2 py-2', className)}>
      <BrandIcon icon={icon} className="size-body-sm-ln shrink-0 self-start" />
      {children}
    </div>
  )
}

export interface LabelProps {
  label?: ReactNode
  errorMessage?: ReactNode
  hidden?: boolean
  variant?: AllVariantPaths
  className?: string
}
export const Label = forwardRef<
  HTMLLabelElement,
  LabelHTMLAttributes<HTMLLabelElement> & LabelProps
>(function Label(
  {
    label,
    hidden = false,
    variant = 'forms.label',
    errorMessage,
    children,
    ...props
  },
  ref,
) {
  return (
    <label
      aria-hidden={hidden}
      ref={ref}
      sx={{
        cursor: 'pointer',
        variant,
      }}
      {...props}
    >
      {label && !hidden && <span className="label-md pb-2">{label}</span>}
      {children}
      {errorMessage && !hidden && (
        <FormFieldErrorMessage errorMessage={errorMessage} />
      )}
    </label>
  )
})
